import {
  PreviewBusiness,
  PreviewCoupon,
  PreviewEvent,
  PreviewFeedback,
  PreviewLinks,
  PreviewSocial,
  PreviewVideo,
  PreviewWebsite,
  PreviewWifi,
  PreviewYoutube,
  PreviewMp3,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "@/components/previews";

import { AppsTemplate } from "@/features/previews/templates/apps";
import { VcardTemplate } from "@/features/previews/templates/vcard";
import { PdfPreview } from "@/features/previews/templates/pdf";
import { UrlTemplate } from "@/features/previews/templates/url";
import { ImagesPreview } from "@/features/previews/templates/images";
import { EmptyPreview } from "@/features/previews/templates/empty";

import { previewRegistry } from "./PreviewRegistry";
import { QRProps } from "../types";

let initialized = false;

// Registers every legacy preview component under the same keys as `data.type`.
export const initializePreviewRegistry = (): void => {
  if (initialized) {
    return;
  }
  initialized = true;

  previewRegistry.registerLegacy("website", PreviewWebsite);
  previewRegistry.registerLegacy("listoflinks", PreviewLinks);
  previewRegistry.registerLegacy("business", PreviewBusiness);
  previewRegistry.register(
    "image",
    ImagesPreview,
    () =>
      import("@/features/previews/templates/images/initPreviewImagesData.json") as unknown as Promise<
        QRProps<"image">
      >
  );
  previewRegistry.registerLegacy("video", PreviewVideo);
  previewRegistry.registerLegacy("wifi", PreviewWifi);
  previewRegistry.registerLegacy("youtube", PreviewYoutube);
  previewRegistry.registerLegacy("social", PreviewSocial);
  previewRegistry.registerLegacy("event", PreviewEvent);
  previewRegistry.registerLegacy("coupon", PreviewCoupon);
  previewRegistry.registerLegacy("feedback", PreviewFeedback);
  previewRegistry.registerLegacy("mp3", PreviewMp3);
  previewRegistry.registerLegacy("text", PreviewText);
  previewRegistry.registerLegacy("email", PreviewEmail);
  previewRegistry.registerLegacy("url-static", PreviewUrlStatic);
  previewRegistry.registerLegacy("sms", PreviewSMS);
  previewRegistry.registerLegacy("whatsapp", PreviewWhatsapp);

  previewRegistry.register(
    "empty" as any,
    EmptyPreview,
    () =>
      import("@/features/previews/templates/empty/initPreviewEmptyData.json") as unknown as Promise<
        QRProps<any>
      >
  );

  previewRegistry.register(
    "apps",
    AppsTemplate,
    () =>
      import("@/features/previews/templates/apps/initPreviewAppsData.json") as unknown as Promise<
        QRProps<"apps">
      >
  );

  previewRegistry.register(
    "vcard",
    VcardTemplate,
    () =>
      import("@/features/previews/templates/vcard/initPreviewVcardData.json") as unknown as Promise<
        QRProps<"vcard">
      >
  );

  previewRegistry.register(
    "pdf",
    PdfPreview,
    () =>
      import("@/features/previews/templates/pdf/initPreviewData.json") as unknown as Promise<
        QRProps<"pdf">
      >
  );

  previewRegistry.register(
    "url",
    UrlTemplate,
    () =>
      import("@/features/previews/templates/url/initPreviewUrlData.json") as unknown as Promise<
        QRProps<"url">
      >
  );
};
